<template>
  <div class="user-wrapper">
    <div class="content-box">
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <a-avatar class="avatar" size="small" :src="avatar"/>
          <span class="nickname">{{ nickname }}</span>
        </span>
        <template #overlay>
          <a-menu class="user-dropdown-menu-wrapper">
            <a-menu-item key="4" @click="showUserInfo">
              <a>
                <SettingOutlined/>
                <span>用户信息</span>
              </a>
            </a-menu-item>
            <a-menu-divider/>
            <a-menu-item key="3" @click="handleLogout">
              <a>
                <LogoutOutlined/>
                <span>退出登录</span>
              </a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import {mainStore} from "@/store";
import {computed, createVNode} from "vue";
import {
  SettingOutlined,
  LogoutOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons-vue'
import {Modal} from 'ant-design-vue';
import {useRouter} from "vue-router";
import defaultAvatar from '@/assets/default.jpg'

export default {
  name: "UserMenu",
  components: {
    SettingOutlined,
    LogoutOutlined,
  },
  setup() {
    const store = mainStore();
    const router = useRouter();
    const handleLogout = () => {
      Modal.confirm({
        title: '退出登录',
        icon: createVNode(ExclamationCircleOutlined),
        content: '确定退出登录吗?',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          store.userLogout().then(()=> {
            router.push({ path: '/user/login' });
          });
        },
      });
    };
    const showUserInfo = () => {

    };
    return {
      nickname: computed(() => store.username),
      avatar: computed(() => store.avatar?store.avatar:defaultAvatar),
      handleLogout,
      showUserInfo,
    }
  }
}
</script>

<style scoped lang="scss">
.user-dropdown-menu-wrapper {
  .ant-dropdown-menu-item {
    width: 100% !important;
  }
}
</style>